export enum SubscriptionType {
  OUTREACH = 'OUTREACH',
  LEAD_FINDER = 'LEAD_FINDER',
  INBOX_RADAR = 'INBOX_RADAR',
  AI = 'AI',
  CRM = 'CRM',
}

export type IProps = {
  isInvoice?: boolean;
  planDetailHeading?: string;
  planDescription?: string;
  userQuota?: number;
  openBillingPortal?: () => void;
  summaryText?: string;
  subscriptionPlanStatus?: string;
  sendGetReactivateSubscriptionRequestStatus?: string;
  handlePauseCancelSubscription?: () => void;
  onCloseReactivateSubscriptionModal?: () => void;
  onCloseResumeSubscriptionModal?: () => void;
  openReactivateSubscriptionModal?: () => void;
  openResumeSubscriptionModal?: () => void;
  reactivateSubscription?: () => void;
  showReactivateSubscriptionModal?: boolean;
  showResumeSubscriptionModal?: boolean;
  resumeSubscription?: () => void;
  sendGetResumeSubscriptionRequestStatus?: string;
  pauseEndsAt?: string;
  pausedAt?: string;
  ltdExpiryDate?: string;
  isPaymentActionRequired?: boolean;
  subscriptionType?: SubscriptionType;
  paymentProvider?: string;
};
